import React from 'react'
import { useLocation } from 'react-router-dom'
import DataLayerService from '../../../services/DataLayerService'
import NewFillButton from '../NewFillButton'
import { GreenButton } from './GreenButton'

export const ContinueButton = ({ onClick, ...props }) => {
  const location = useLocation()

  const clicked = () => {
    DataLayerService.pushToDataLayer({
      event: `continue-button-at-${location.pathname
        .split('/')
        .slice(-1)
        .pop()}`,
    })
    onClick && onClick()
  }

  return (
    // <GreenButton flat onClick={clicked} {...props}>Continue</GreenButton>
    <NewFillButton flat onClick={clicked} {...props}>
      Continue
    </NewFillButton>
  )
}
